export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    Ok = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    ImUsed = 226,
    MultipleChoices = 300,
    MovedPermanently = 301,
    Found = 302,
    SeeOther = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    PayloadTooLarge = 413,
    UriTooLong = 414,
    UnsupportedMediaType = 415,
    RangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    ImATeapot = 418,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    Locked = 423,
    FailedDependency = 424,
    TooEarly = 425,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export enum LanguageCode {
    EN = "en-US",
    BM = "ms-MY",
}

export enum UserRole {
    SuperAdmin = "super_admin",
    Admin = "admin",
    Researcher = "researcher",
    Clinician = "clinician",
    Patient = "patient",
    Staff = "staff",
}

export enum PagePermissionEnum {
    ALERT = "alert",
    APPOINTMENT = "appointment",
    CALENDAR = "calendar",
    CHECKIN = "checkin",
    CONSULTATIONS = "consultations",
    DATA_REQUEST = "data_request",
    DEVICE = "device",
    DEVICE_MODEL = "device_model",
    DEVICE_MODEL_READONLY = "device_model_readonly",
    DISEASE = "disease",
    FACILITY = "facility",
    FAQ = "faq",
    FEEDBACK = "feedback",
    FEEDBACK_APP = "feedback_app",
    FEEDBACK_WEB = "feedback_web",
    MEDICINE = "medicine",
    MONITORING = "monitoring",
    NOTIFICATION = "notification",
    PARAMETER = "parameter",
    PATIENT = "patient",
    DISEASE_READONLY = "disease_readonly",
    PERMISSION = "permission",
    PROJECT = "project",
    RESEARCHER = "researcher",
    ROLE = "role",
    TICKET = "ticket",
    TRANSFER = "transfer",
    USER = "user",

    CLINICIAN = "clinician",
    ADMIN = "admin",
    SUPERADMIN = "super_admin",
    STAFF = "staff",

    COMMUNITY_CENTRE = "community_centre",
    COMMUNITY_CENTRE_PATIENT = "community_centre_patient",

    DISABLED = "disabled",
}

export enum RiskLevel {
    LOWRISK = "1 - Low Risk",
    MODERATERISK = "2 - Moderate Risk",
    HIGHRISK = "3 - High Risk",
    VERYHIGHRISK = "4 - Very High Risk",
    EXTREMERISK = "5 - Extreme Risk",
}

export enum AccessoryStatus {
    Assignable = "Assignable",
    Assigned = "Assigned",
    PendingRetrievedH = "Pending Retrieved - Hospitalization",
    PendingRetrievedUT = "Pending Retrieved - Unexpected Transfer",
    Lost = "Lost",
    Faulty = "Faulty",
    Deactivate = "Deactivate"
}

export enum DeviceStatus {
    Assignable = "Assignable",
    Assigned = "Assigned",
    PendingRetrievedH = "Pending Retrieved - Hospitalization",
    PendingRetrievedUT = "Pending Retrieved - Unexpected Transfer",
    Lost = "Lost",
    Faulty = "Faulty",
    Deactivate = "Deactivate"
}

export enum AmPm {
    am = "AM",
    pm = "PM",
}

export enum AppointmentType {
    online = "Virtual",
    offline = "Physical",
}

export enum ClinicianStatus {
    offline = "Offline",
    online = "Online",
    "on-break" = "On-Break",
    "on-duty" = "On-duty",
    "in-call" = "In Call",
    ED = "ED",
}

export enum AppointmentStatus {
    PENDING = "pending",
    COMPLETED = "completed",
    DID_NOT_ATTEND = "did_not_Attend",
    RESCHEDULED = "rescheduled",
    INCOMPLETE = "incomplete",
    MISSING_IN_ACTION = "missing_in_action",
    CANCELLED = "cancelled",
}

export enum ProjectStatus {
    CLOSED = "Closed",
    ONGOING = "On-going",
    NEW = "New",
    ONHOLD = "On-hold"
}

export enum MonitoringStatus {
    in_monitoring = "in_monitoring"
}

export enum DiagnosisType {
    GENERAL = "general",
    CONSULTATION = "consultation",
}

export enum DiagnosisStatus {
    DRAFT = "draft",
    SUBMITTED = "submitted",
}
